import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchWorkspaceConfig } from "../slices/workspaceConfigSlice";

/**
 * Load the active workspace's config whenever the session's workspace changes
 * and its config is not already loaded. Covers every path that sets the
 * workspace: the landing pick after `/users`, the switcher, and a deep link.
 * The fetch dedupes against an in-flight or loaded entry, so the switch
 * thunk's own fetch for the same workspace costs nothing extra.
 */
export const useWorkspaceConfigLoader = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const userDataFetched = useSelector((state) => state.auth.userDataFetchedThisSession);
  const idClient = useSelector((state) => state.auth.id_client);

  useEffect(() => {
    if (!isAuthenticated || !userDataFetched || !idClient) return;
    dispatch(fetchWorkspaceConfig({ idClient }));
  }, [dispatch, isAuthenticated, userDataFetched, idClient]);
};
